var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.topShow
    ? _c("img", {
        staticClass: "back-top",
        attrs: { src: require("@/static/img/returntop.png") },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.backTop.apply(null, arguments)
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }